import { TextInput } from "@mantine/core";
import { PatternFormat } from "react-number-format";

interface PhoneInputProps {
  autoFocus?: boolean;
  onChange: (phoneNumber: string) => void;
}

export const PhoneInput = ({ autoFocus, onChange }: PhoneInputProps) => {
  return (
    <PatternFormat
      allowEmptyFormatting
      autoFocus={autoFocus}
      className="w-full my-2"
      customInput={TextInput}
      format="(###) ###-####"
      mask="_"
      onValueChange={({ value }) => onChange(value)}
      size="md"
      type="tel"
    />
  );
};
